import dayjs from '@/utils/dayjs';
import Altinn from './Altinn';
import i18n from '@/i18n';
import Decimal from 'decimal.js-light';
import { GQL_AltinnEmploymentTypeEnum } from '@/queries/global';

export const isEmployedDuringPeriod = (
  workRelation: { startDate: string; endDate?: string },
  period: { startDate: string; endDate: string },
) => {
  if (!workRelation.endDate) {
    return dayjs.strict(workRelation.startDate).isSameOrBefore(period.endDate, 'day');
  }

  return (
    dayjs.strict(period.startDate).isBetween(workRelation.startDate, workRelation.endDate, 'day', '[]') ||
    dayjs.strict(period.endDate).isBetween(workRelation.startDate, workRelation.endDate, 'day', '[]') ||
    dayjs.strict(workRelation.startDate).isBetween(period.startDate, period.endDate, 'day', '[]') ||
    dayjs.strict(workRelation.endDate).isBetween(period.startDate, period.endDate, 'day', '[]')
  );
};

export const isEndedForPeriod = (
  workRelation: { startDate: string; endDate?: string },
  period: { startDate: string; endDate: string },
) => {
  if (!workRelation.endDate) { return false }

  return dayjs.strict(workRelation.endDate).isBefore(period.startDate, 'day');
};

export const isNotStartedForPeriod = (
  workRelation: { startDate: string; endDate?: string },
  period: { startDate: string; endDate: string },
) => {
  return dayjs.strict(workRelation.startDate).isAfter(period.endDate, 'day');
};

interface IWorkRelationDisplay {
  employmentPercentage: Decimal | null;
  employmentType: GQL_AltinnEmploymentTypeEnum;
  occupation: {name: string} | null;
  employee: {firstName: string; lastName: string};
  subUnit: {name: string} | null;
}

export const workRelationDisplay = (workRelation: IWorkRelationDisplay, displaySubunit = false): string => {
  let result = `${workRelation.employee.firstName} ${workRelation.employee.lastName}`;
  if (displaySubunit && workRelation.subUnit) result += ` - ${workRelation.subUnit.name}`;
  if (workRelation.occupation?.name) result += ` - ${workRelation.occupation?.name}`;
  if (workRelation.employmentType === Altinn.pensionEmploymentType) result += ` (${i18n.t('PaycheckDraft.wrPension')})`;
  if (workRelation.employmentPercentage) result += ` ${workRelation.employmentPercentage}%`;
  return result;
};
